import React from 'react';
import AutomaticDrawer from 'components/Drawers/AutomaticDrawer';
import useQueryParams from 'hooks/useQueryParams';
import { snackbar } from 'components/notifications/notifications';
import { useCreateCustomCostMutation } from 'modules/PnLReportModule/api/customCost.api';
import CustomCostForm from './components/CustomCostForm';

const CreateCustomCostDrawer = (props) => {
  const { removeParams } = useQueryParams();
  const [createCustomCoost, { isLoading }] = useCreateCustomCostMutation();

  const onSubmit = (data) => {
    createCustomCoost(data)
      .unwrap()
      .then((u) => {
        snackbar.success(`${u.name} create successfully`);
        removeParams(['create_custom_cost']);
      });
  };

  return (
    <AutomaticDrawer size='small' title='Create Custom Cost' {...props}>
      <CustomCostForm onSubmit={onSubmit} isLoading={isLoading} />
    </AutomaticDrawer>
  );
};

CreateCustomCostDrawer.requiredParams = {
  create_custom_cost: true,
};

export default CreateCustomCostDrawer;
